import isEqual from 'lodash/isEqual'

export default {
    // Обновление реестра
    ADD_TO_ORDERS(state, lists) {
        state.all_orders = lists || []
    },
    REFRESH_ORDERS(state, { lists }) {
        state.all_orders = lists || []
    },
    // Пагинация
    SET_COUNT(state, count) {
        state.totalOrders = count
    },
    SET_SUM_PRICE(state, sum) {
        state.totalPrice = sum
    },
    SET_SUM_FINAL_PRICE(state, sum) {
        state.totalFinalPrice = sum
    },
    SET_CURRENT_PAGE(state, page) {
        state.currentPage = page
    },
    SET_PARAMS(state, params) {
        Object.entries(params).forEach(([key, value]) => {
            if (
                key in state.paramsSearch &&
                !isEqual(state.paramsSearch[key], value)
            ) {
                state.paramsSearch[key] = value
            }
        })
    },
    // Справочники для фильтров
    ADD_TO_STATUSES(state, { data }) {
        data.eds_order_status.forEach(e => {
            state.statuses.push(e)
        })
    },
    ADD_TO_RESTAURANTS(state, restaurants) {
        state.restaurants = restaurants
    },
    SET_BRANDS(state, brands) {
        state.brands = brands
    },
    ADD_TO_OPERATORS(state, { data }) {
        data.eds_user.forEach(e => {
            state.operators.push(e)
        })
    },
    SET_NUMBER_OF_ORDERS_WITH_ERROR(state, { data }) {
        state.numberOfOrdersWithSendError =
            data.eds_order_status[0].eds_orders_aggregate.aggregate.count
    },
    SET_ERROR_ORDERS_DATA(state, data) {
        state.errorOrdersData = data
    },
    // Выбор строчки в реестре
    SET_PREVIEW_ORDER(state, { data }) {
        if (!data.order) {
            state.view_order = null
        } else {
            const { order } = data
            if (order) {
                state.view_order = order
                const { guest, phone, payments } = order
                state.view_order.contact = phone
                state.view_order.final_price = payments
                    ? payments[0].final_price
                    : ''
                state.view_order.price = payments ? payments[0].price : ''
                state.view_order.guestName = guest ? guest.first_name : ''
                if (
                    order.restaurant &&
                    order.restaurant.stop_lists &&
                    order.restaurant.stop_lists.length > 0
                ) {
                    state.stopList = order.restaurant.stop_lists
                } else {
                    state.stopList = []
                }
            }
        }
    },

    CANCEL_ORDER(state, { id }) {
        const order = state.all_orders.find(e => e.id === id)
        if (order != null) {
            order.group1.status = 'ОТМЕНЕН'
        }
    },
    // TODO? Как будто бы не используется
    SET_STOP_LIST(state, { stopList }) {
        state.stopList = stopList
    },
    SET_NOTIFICATIONS(state, data) {
        if (data) {
            state.notifications = []
            data.forEach(item => {
                state.notifications.push(item)
            })
        } else {
            state.notifications = null
        }
    },

    // Значение обновления реестра
    SET_TIMER(state, timer) {
        state.timeUpdateList = timer
    },

    SET_COOKERY_INTERVALS(state, ints) {
        state.cookeryIntervals = ints
    },

    SET_CANCELED_ORDER_NOTIFICATION(state, payload) {
        state.managerNotifications.canceledOrderNotification = payload
    },

    SET_CHANGED_ORDER_NOTIFICATION(state, payload) {
        state.managerNotifications.changedOrderNotification = payload
    },

    SET_DISPATCHER_ORDER_NOTIFICATION(state, payload) {
        if (payload === null) {
            state.managerNotifications.dispatcherOrderNotifications = []
            return
        }
        state.managerNotifications.dispatcherOrderNotifications.push(payload)
    },

    SET_PREVIEW_ORDER_ID(state, id) {
        state.previewOrderId = id
    },

    SET_UNBLOCKED_ORDER(state, payload) {
        state.unblockedOrder = payload
    },

    SET_CONFIRMED_UNBLOCKED_ORDER_ID(state, payload) {
        state.confirmedUnblockedOrderId = payload
    },

    SET_UNBLOCK_TIMER(state, payload) {
        state.unblockTimer = payload
    },
}
